import { Switch } from 'antd'
import moment from 'moment'
import { render } from 'react-dom'

export const config = {
  rowSelection: false,
  columns: [
    {
      title: '需求标签',
      dataIndex: 'bizOpTypeName',
      width: 200,
      name: 'bizOpTypeName',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '地理位置',
      dataIndex: 'regionName',
      width: 200,
      name: 'regionName',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '门店名称',
      dataIndex: 'companyName',
      width: 200,
      name: 'companyName',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '是否接单',
      dataIndex: 'enable',
      width: 200,
      render: 'enableRender'
    },
    {
      title: '分配人',
      dataIndex: 'userName',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 180,
      ellipsis: {
        showTitle: false,
      },
      render: v => {
        return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
      },
    },
    {
      title: '操作',
      key: 'action',
      width: 200,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      label: '城市',
      name: 'cityCode',
      itemType: 'select',
      labelKey: 'regionName',
      key: 'regionCode',
      data: 'regionList',
    },
    {
      label: '门店',
      name: 'storeId',
      itemType: 'select',
      labelKey: 'name',
      key: 'id',
      data: 'companyList',
    },
    {
      label: '需求标签',
      name: 'bizType',
      itemType: 'select',
      labelKey: 'description',
      key: 'key',
      data: 'BizOpTypeEnumList',
    },
  ],
  footer: [],
}
